import { useEffect, useRef } from 'react';
import { isClickInsideDatePicker } from './helpers/isClickInsideDatePicker';
import { TProps } from './types/TProps';

export const ClickAway = ({ children, ignoreElement, onClickAway, className = '' }: TProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const onClick = (e: MouseEvent) => {
    if (isClickInsideDatePicker(e.target)) {
      return;
    }
    if (ignoreElement?.contains(e.target as Node)) {
      return;
    }
    if (ref.current && !ref.current.contains(e.target as HTMLElement)) {
      onClickAway(e);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', onClick);
    return () => {
      document.removeEventListener('mousedown', onClick);
    };
  }, []);

  return (
    <div className={`absolute contents ${className}`.trim()} ref={ref}>
      {children}
    </div>
  );
};
